import React, { useState } from "react";
import ConflictOfInterest from "../../Pages/Submitter/ConflictOfInterestAndResearchEthicsPage/ConflictOfInterest";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  UpdateConflictOfInterestList,
  ValidateConflictOfInterest,
} from "../../Redux/Reducers/Submitter/ConflictsOfInterestAndResearchEthics";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import PopupAHSF from "../../Components/PopupAHSF";
import $ from "jquery";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";

function ConflictOfInterestAndResearchEthics() {
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  console.log(encryptedToken, "slkdslkdlksdl");
  var guid =
    encryptedToken[encryptedToken.length - 1] != null
      ? decryptToken(encryptedToken[encryptedToken.length - 1])
      : null;
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      ConflictOfInterest: state.ConflictOfInterest.ConflictOfInterest,
      ConflictOfInterestUpdate:
        state.ConflictOfInterest.ConflictOfInterestUpdate,
      loadingConflictOfInterest:
        state.ConflictOfInterest.loadingConflictOfInterest,

      ConflictOfInterestValidate:
        state.ConflictOfInterest.ConflictOfInterestValidate,
    };
  });
  console.log(state.ConflictOfInterestValidate, "red");

  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  const SaveDataPage = async (withValidate) => {
    // const merged = Object.values(state.ConflictOfInterest).flatMap((item) => item.value);
    // console.log(state.ConflictOfInterest,"state.ConflictOfInterest",merged);

    // const saved = await dispatch(
    //   UpdateConflictOfInterestList({
    //     updateListSU_NT_COIARE_ConflictsOfInterestAndResearchEthics:merged,
    //   })
    // );

    if (withValidate) {
      const validate = await dispatch(
        ValidateConflictOfInterest(
          localStorage.getItem("ApplicationInformationId")
        )
      );

      if (validate.payload?.length > 0) {
        setisPopupOpenStatus(true);
      } else {
        $(".AttachmentsAndPledge").trigger("click");

        navigate("/SRFund/AttachmentsAndPledge");
      }
    }
  };
  const shouldDisableFields = !(

    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.applicationStatusId == "57ca8392-5b8e-4625-8a37-00dfc27d5b28" ? true :
      ActiveRound == ApplicationInformation?.aI_RoundYearId &&
      ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
      window.location.href.includes("manager") == false
  );

  return (
    <>
      <ConflictOfInterest
        applicationGuid={guid}
        shouldDisableFields={shouldDisableFields}
      />
      ;
      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(false);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            }}
            disabled={false}
            title={"حفظ"}
            text={"حفظ"}
            show={true}
          />
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true);
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى الاجابة على جميع الاسئلة المطلوبة"
        componentBody={state.ConflictOfInterestValidate}
      />
    </>
  );
}

export default ConflictOfInterestAndResearchEthics;
